<div class="content-wrapper container-xxl p-0">
	<div class="content-body">

		<app-content-header [contentHeader]="contentHeader"></app-content-header>

		<!-- Modal plano -->
		<ng-template #modalBasic let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione o plano</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="planos" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Plano</h3>
							<input type="search" placeholder="Plano" class="ml-25 form-control"
								(keyup)="textFilter($event, 'plano')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.plano}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Pacote</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'pacote')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.pacote}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor Mensal</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'valor_mensal')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">R$ {{row.valor_mensal || currencyMask}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Operadora</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome_operadora')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome_operadora}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Broker</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome_broker')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome_broker}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="selectPlano(row)" rippleEffect>
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal plano-->

		<!-- Modal Valores -->
		<ng-template #modalBasicValores let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Valores da Tabela</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<button type="button" (click)="modal.dismiss('Cross click')"
					class="btn btn-outline-secondary btn-apply-changes mr-1 mb-1" rippleEffect>
					<i data-feather="arrow-left" class="ml-25"></i>
					Voltar para Tabelas
				</button>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="itensModal" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Quantidade de inicio</h3>
							<input type="search" placeholder="Quantidade de inicio" class="ml-25 form-control"
								(keyup)="textFilter($event, 'qtd_inicio')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.qtd_inicio}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Quantidade de Fim</h3>
							<input type="search" placeholder="Quantidade de final" class="ml-25 form-control"
								(keyup)="textFilter($event, 'qtd_fim')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.qtd_fim}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor p/ Ativo</h3>
							<input type="search" placeholder="Valor p/ Ativo" class="ml-25 form-control"
								(keyup)="textFilter($event, 'valor_ativo')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">R$ {{row.valor_ativo}}</span>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal Valores-->

		<!-- Modal tabelas -->
		<ng-template #modalBasicTabelas let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione a Tabela de Preço</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>

			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="itensTabelaPreco" [scrollbarH]="true">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Nome da Tabela</h3>
							<input type="search" placeholder="Nome da Tabela" class="ml-25 form-control"
								(keyup)="textFilter($event, 'nome')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.nome}}</span><br>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-secondary btn-sm btn-add-new mr-1"
										(click)="visualizarValoresTabela(modalBasicValores,row.itens)" rippleEffect>
										Visualizar Valores
									</button>
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="definirTabela(row)" rippleEffect>
										Selecionar
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>



		</ng-template>
		<!-- / Modal tabelas-->

		<!-- Modal desconto-->
		<ng-template #modalBasicDesconto let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Selecione o Desconto</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<!-- DATATABLE -->
				<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
					[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
					style="box-shadow: none" [rows]="descontos" [scrollbarH]="false">

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Desconto</h3>
							<input type="search" placeholder="Desconto" class="ml-25 form-control"
								(keyup)="textFilter($event, 'plano')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold">{{row.desconto}}</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Valor/Percentual</h3>
							<input type="search" placeholder="Pacote" class="ml-25 form-control"
								(keyup)="valorFilter($event)" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold" *ngIf="row.valor">R$ {{row.valor}}</span>
							<span class="font-weight-bold" *ngIf="row.percentual">{{row.percentual}}%</span>
							<span class="font-weight-bold" *ngIf="!row.percentual && !row.valor">-</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [sortable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<h3>Tempo</h3>
							<input type="search" placeholder="Tempo" class="ml-25 form-control"
								(keyup)="textFilter($event, 'tempo')" />
						</ng-template>
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<span class="font-weight-bold" *ngIf="row.percentual || row.valor">{{row.tempo}} Dias</span>
							<span class="font-weight-bold" *ngIf="!row.percentual && !row.valor">-</span>
						</ng-template>
					</ngx-datatable-column>

					<!-- COLUNA -->
					<ngx-datatable-column [width]="20" [sortable]="false">
						<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
							let-row="row">
							<div class="d-flex align-items-center" style="float: right">
								<div ngbDropdown container="body">
									<button type="button" class="btn btn-primary btn-sm btn-add-new"
										(click)="selectDesconto(row)" rippleEffect>
										<i data-feather="arrow-right" class="mr-25"></i>
									</button>
								</div>
							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</ng-template>
		<!-- / Modal desconto-->

		<section class="invoice-add-wrapper">
			<div *ngIf="starting" class="card invoice-preview-card">
				<div class="card-body invoice-padding pb-2 pt-2">
					<div class="progress-wrapper">
						<ngb-progressbar [striped]="true" [animated]="true" [value]="100"></ngb-progressbar>
					</div>
				</div>
			</div>
			<div *ngIf="!starting" class="row invoice-add">
				<div class="col-xl-9 col-md-8 col-12">
					<div class="card invoice-preview-card">
						<!-- Header bar that's always visible -->
						<div class="card-header d-flex justify-content-between align-items-center bg-primary" style="cursor: pointer; color: white;" (click)="isPedidoCollapsed = !isPedidoCollapsed">
							<h3 class="mb-0" style="color: white;">Detalhes do Pedido</h3>
							<button class="btn btn-link p-0" type="button" style="color: white;">
								<i class="fa" [ngClass]="isPedidoCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
							</button>
						</div>
				
						<!-- Collapsible content -->
						<div [hidden]="isPedidoCollapsed">
							<div class="card-body invoice-padding pb-0">
								<div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
									<div class="invoice-number-date mt-md-0 mt-2">
										<div *ngIf="pedido.id_pedido != null"
											class="d-flex align-items-center justify-content-md-end mb-1">
											<h4 class="invoice-title">Número do pedido</h4>
											<div class="input-group input-group-merge invoice-edit-input-group disabled">
												<input type="text" class="form-control invoice-edit-input"
													value="{{pedido.num_pedido}}" placeholder="{{pedido.num_pedido}}"
													disabled />
											</div>
										</div>
									</div>
								</div>
							</div>
				
							<div class="card-body invoice-padding pt-0">
								<!-- Título Dados do Pedido -->
								<div class="row">
									<div class="col-12">
										<!-- <h3 class="mb-1">Dados do pedido</h3> -->
									</div>
								</div>
				
								<!-- Add these new select fields -->
								<div class="row row-bill-to invoice-spacing">
									<div class="col-xl-12 pl-0">
										<div class="card">
											<div class="card-body">
												<div class="row">
													<div class="col-md-4">
														<div class="form-group">
															<label>Gerar NF:</label>
															<select class="form-control" [(ngModel)]="pedido.gerarNF" name="gerarNF" [disabled]="modoEdicao">
																<option [ngValue]="true">Sim</option>
																<option [ngValue]="false">Não</option>
															</select>
														</div>
													</div>
													<div class="col-md-4">
														<div class="form-group">
															<label>Instalar na plataforma Rastreei:</label>
															<select class="form-control" [(ngModel)]="pedido.instalarPlataforma" name="instalarPlataforma" [disabled]="modoEdicao">
																<option [ngValue]="true">Sim</option>
																<option [ngValue]="false">Não</option>
															</select>
														</div>
													</div>
													<div class="col-md-4">
														<div class="form-group">
															<label>Chip Rastreei:</label>
															<select class="form-control" [(ngModel)]="pedido.chipRastreei" name="chipRastreei" [disabled]="modoEdicao">
																<option [ngValue]="true">Sim</option>
																<option [ngValue]="false">Não</option>
															</select>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
				
								<div class="row row-bill-to invoice-spacing">
									<!-- Coluna dos Selects (exibida apenas no modo cadastro) -->
									<div class="col-xl-5 col-bill-to pl-0" *ngIf="!isVisualizacao">
										<div class="card">
											<div class="card-body">
												<!-- Cliente -->
												<div class="mb-2">
													<h4 class="invoice-to-title">Cliente:</h4>
													<div class="invoice-customer">
														<input [disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
															type="text" class="form-control"
															placeholder="CPF, CNPJ ou Nome do cliente" (keyup)="onKeyUp($event)"
															[(ngModel)]="termoPesquisa" matInput [matAutocomplete]="auto" />
														<span *ngIf="carregando"
															class="float-left spinner-border spinner-border-sm loading-suffix"></span>
														<mat-autocomplete #auto="matAutocomplete">
															<mat-option *ngFor="let option of clientes" [value]="option.nome"
																(click)="setCliente(option)">
																{{option.nome}}
															</mat-option>
														</mat-autocomplete>
														<br>
														<span *ngIf="clienteNaoEncontrado" class="text-danger">
															Nenhum cliente encontrado.
														</span>
													</div>
												</div>
				
												<!-- Vendedor -->
												<div class="mt-2">
													<h4 class="invoice-to-title">Vendedor:</h4>
													<div class="invoice-customer">
														<select class="form-control" [(ngModel)]="selectedVendedor" name="vendedor"
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null">
															<option [ngValue]="null">Selecione um vendedor</option>
															<option *ngFor="let vendedor of vendedores" [ngValue]="vendedor">
																{{vendedor.nome}}
															</option>
														</select>
													</div>
												</div>
											</div>
										</div>
									</div>
				
									<!-- Coluna Detalhes do Cliente -->
									<div class="col-xl-7 pl-0 pl-xl-1 pl-md-0 mt-xl-0 mt-2" *ngIf="!isVisualizacao">
										<div class="card">
											<div class="card-body">
												<h4 class="mb-2">Detalhes do cliente:</h4>
												<div *ngIf="selectedCliente == null" class="text-muted">
													<strong>Selecione um cliente</strong>
												</div>
												<table *ngIf="selectedCliente != null" class="">
													<tbody>
														<tr>
															<td class="pr-1 font-weight-bold" style="white-space: nowrap;">Contratante:</td>
															<td style="word-break: break-word; max-width: 300px;">{{selectedCliente.nome_contratante}}</td>
														</tr>
														<tr>
															<td class="pr-1 font-weight-bold" style="white-space: nowrap;">Email:</td>
															<td style="word-break: break-word; max-width: 300px;">{{selectedCliente.email_cliente || '-'}}</td>
														</tr>
														<tr>
															<td class="pr-1 font-weight-bold" style="white-space: nowrap;">N. fantasia:</td>
															<td style="word-break: break-word; max-width: 300px;">{{selectedCliente.nome_fantasia}}</td>
														</tr>
														<tr>
															<td class="pr-1 font-weight-bold" style="white-space: nowrap;">Razao social:</td>
															<td style="word-break: break-word; max-width: 300px;">{{selectedCliente.razao_social}}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
				
									<!-- Detalhes do Cliente (modo visualização, ocupa toda a tela) -->
									<div class="col-12 pl-0" *ngIf="isVisualizacao">
										<h4 class="mb-2">Detalhes do cliente:</h4>
										<div *ngIf="selectedCliente == null" class="text-muted">
											<strong>Selecione um cliente</strong>
										</div>
										<table *ngIf="selectedCliente != null" class="table table-sm">
											<tbody>
												<tr>
													<td class="pr-1 font-weight-bold">Contratante:</td>
													<td>{{selectedCliente.nome_contratante}}</td>
												</tr>
												<tr>
													<td class="pr-1 font-weight-bold">Email:</td>
													<td>{{selectedCliente.email_cliente || '-'}}</td>
												</tr>
												<tr>
													<td class="pr-1 font-weight-bold">N. fantasia:</td>
													<td>{{selectedCliente.nome_fantasia}}</td>
												</tr>
												<tr>
													<td class="pr-1 font-weight-bold">Razao social:</td>
													<td>{{selectedCliente.razao_social}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
				
							<hr class="invoice-spacing" />
							<div class="card-body invoice-padding invoice-product-details" style="background-color: #fff;">
								<h3 style="font-size: 20px; font-weight: bold; margin-top: -35px;">
									<!-- <i data-feather="codepen" class="mr-25"></i> -->
									Lista de Produtos
								</h3>
								<br><br>
								<form class="source-item">
									<div data-repeater-list="group-a">
										<div class="repeater-wrapper" data-repeater-item
											*ngFor="let item of itensPedidoProduto; let i = index" @heightIn>
											<div class="row">
												<div class="col-12 d-flex product-details-border position-relative pr-0">
													<div class="row w-100 pr-lg-0 pr-1 py-2">
														<div class="col-lg-5 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2" *ngIf="!modoEdicao">
															<p class="card-text col-title mb-md-50 mb-0">Rastreador</p>
															<select
																class="form-control item-details" name="tipo-item"
																[(ngModel)]="item.id_rastreador_modelo"
																(change)="selectItem($event, i)">
																<option [value]="null" selected>Selecione um rastreador</option>
																<option *ngFor="let modelo of modelosRastreador"
																	[value]="modelo.id_rastreador_modelo">
																	{{modelo.nome}}
																</option>
															</select>
														</div>
														<div class="col-lg-5 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2" *ngIf="modoEdicao">
															<p class="card-text col-title mb-md-50 mb-0">Rastreador</p>
															<span>{{item.modelo}}</span>
														</div>
				
														<div class="col-lg-2 col-12 my-lg-0 my-2">
															<p class="card-text col-title mb-md-2 mb-0">Valor Negociado</p>
															<input
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																prefix="R$ " type="text" (keyup)="alterarTotal()"
																mask="separator.2" [(ngModel)]="item.itemValor"
																id="itemValor{{ i }}" name="itemValor{{ i }}" class="form-control"
																placeholder="R$ 100" required />
															<div class="mt-1"
																[hidden]="item.itemValor != null && item.itemValor != 0 || item.id_rastreador_modelo == null">
																<span style="color: #ef6767;"><b>* Obrigatório</b></span>
															</div>
				
				
														</div>
														<div class="col-lg-2 col-12 my-lg-0 my-2">
															<p class="card-text col-title mb-md-2 mb-0">Qtd</p>
															<input
																[disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
																type="number" class="form-control" (keyup)="alterarTotal()"
																(change)="alterarTotal()" id="itemQuantity{{ i }}"
																name="itemQuantity{{ i }}" min='0'
																[(ngModel)]="item.quantidade" placeholder="0" />
															<div class="mt-1"
																[hidden]="item.quantidade != null && item.quantidade != 0 || item.id_rastreador_modelo == null">
																<span style="color: #ef6767;"><b>* Obrigatório</b></span>
															</div>
				
				
														</div>
														<div class="col-lg-3 col-12 mt-lg-0 mt-2">
															<p class="card-text col-title mb-md-50 mb-0">Subtotal</p>
															<p class="card-text mb-0">R$ {{(item.itemValor *
																item.quantidade).toFixed(2)}}</p>
				
														</div>
													</div>
													<div
														class="d-flex flex-column align-items-center justify-content-between border-left invoice-product-actions py-50 px-25">
														<button (click)="deleteItem(i)" class="btn p-0"
															[disabled]="pedido.id_status == 2 || pedido.id_pedido != null">
															<i data-feather="x" [size]="18" class="cursor-pointer"></i>
														</button>
													</div>
												</div>
											</div>
										</div>
										<div *ngIf="itensPedidoProduto.length == 0">Não há produtos adicionados no pedido
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-12 px-0">
											<button [disabled]="pedido.id_status == 2 || pedido.id_pedido != null"
												type="button" class="btn btn-primary btn-sm btn-add-new ml-1"
												(click)="addItem()" rippleEffect>
												<i data-feather="plus" class="mr-25"></i>
												<span class="align-middle">Adicionar Produto</span>
											</button>
										</div>
									</div>
								</form>
							</div>
				
							<div class="card-body invoice-padding">
								<div class="row invoice-sales-total-wrapper">
									<div class="col-md-6 order-md-1 order-2 mt-md-0 mt-3">
										<div class="d-flex align-items-center mb-1">
										</div>
									</div>
									<div class="col-md-6 d-flex justify-content-end order-md-2 order-1">
										<div class="invoice-total-wrapper">
				
											<!-- <hr class="my-50" />
											<div class="invoice-total-item">
												<h3 class="invoice-total-title">Subtotal:</h3>
												<h3 class="invoice-total-amount">R$ {{valorTotal.toFixed(2)}}</h3>
											</div>
											<hr class="my-50" />
											<div class="invoice-total-item">
												<h2 class="invoice-total-title">Total:</h2>
												<h2 class="invoice-total-amount">R$ {{valorTotal.toFixed(2)}}</h2>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Separação de Pedido section - only shown when id_status equals 4 -->
					<div class="card invoice-preview-card mt-2" *ngIf="pedido.id_status >= 4">
						<!-- Header bar that's always visible -->
						<div class="card-header d-flex justify-content-between align-items-center bg-primary" style="cursor: pointer; color: white;" (click)="isSeparacaoCollapsed = !isSeparacaoCollapsed">
							<h3 class="mb-0" style="color: white;">Separação de Pedido</h3>
							<button class="btn btn-link p-0" type="button" style="color: white;">
								<i class="fa" [ngClass]="isSeparacaoCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
							</button>
						</div>
				
						<!-- Collapsible content -->
						<div [hidden]="isSeparacaoCollapsed">
							<div class="card-body invoice-padding pt-2">
								<div class="row">
									<div class="col-12">
										<div class="form-group mb-2">
											<label for="imeis"><strong>IMEIs dos Rastreadores</strong> (um por linha)</label>
											<textarea [(ngModel)]="imeisParaSeparacao" name="imeisParaSeparacao" class="form-control" rows="8" 
												placeholder="Cole ou digite os IMEIs dos rastreadores, um por linha"
												[disabled]="pedido.id_status >= 5"></textarea>
											<small class="form-text text-muted">Digite os IMEIs dos produtos que serão separados para esse pedido.</small>
											<div class="mt-1 text-right">
												<span class="badge badge-primary">
													{{contarImeis()}} IMEIs informados
												</span>
											</div>
										</div>
										<div class="mt-2">
											<button type="button" class="btn btn-primary" (click)="confirmarSeparacao()" 
												[disabled]="!imeisParaSeparacao || imeisParaSeparacao.trim() === ''"
												*ngIf="pedido.id_status == 4">
												<i data-feather="check" class="mr-25"></i>
												Confirmar Separação
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Configuração section - only shown when id_status equals 5 -->
					<div class="card invoice-preview-card mt-2" *ngIf="pedido.id_status >= 5">
						<!-- Header bar that's always visible -->
						<div class="card-header d-flex justify-content-between align-items-center bg-primary" style="cursor: pointer; color: white;" (click)="isConfiguracaollapsed = !isConfiguracaollapsed">
							<h3 class="mb-0" style="color: white;">Configuração</h3>
							<button class="btn btn-link p-0" type="button" style="color: white;">
								<i class="fa" [ngClass]="isConfiguracaollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
							</button>
						</div>
				
						<!-- Collapsible content -->
						<div [hidden]="isConfiguracaollapsed">
							<div class="card-body invoice-padding pt-2">
								<div class="row">
									<div class="col-12">
										<div class="form-group mb-2">
											<label><strong>Necessita de Configuração?</strong></label>
											<select class="form-control" [(ngModel)]="necessitaConfiguracao" name="necessitaConfiguracao" 
												[disabled]="pedido.id_status >= 6">
												<option [ngValue]="true">Sim</option>
												<option [ngValue]="false">Não</option>
											</select>
										</div>

										<!-- Configuração options - only shown when necessitaConfiguracao is true -->
										<div *ngIf="necessitaConfiguracao" class="mt-3">
											<div class="row">
												<div class="col-md-6">
													<div class="form-group">
														<label><strong>Plataforma</strong></label>
														<select class="form-control" [(ngModel)]="configuracao.plataforma" name="plataforma" 
															[disabled]="pedido.id_status >= 6">
															<option [ngValue]="'rastreei'">Rastreei</option>
															<option [ngValue]="'outra'">Outra</option>
														</select>
													</div>
													
													<!-- Campos adicionais para plataforma personalizada -->
													<div *ngIf="configuracao.plataforma === 'outra'" class="mt-2">
														<div class="form-group">
															<label><strong>Plataforma: IP/Domínio</strong></label>
															<input type="text" class="form-control" 
																[(ngModel)]="configuracao.plataformaConfig.dominio" 
																name="plataformaIpDominio"
																[disabled]="pedido.id_status >= 6">
														</div>
														<div class="form-group">
															<label><strong>Plataforma: Porta</strong></label>
															<input type="text" class="form-control" 
																[(ngModel)]="configuracao.plataformaConfig.porta" 
																name="plataformaPorta"
																[disabled]="pedido.id_status >= 6">
														</div>
													</div>
												</div>
												
												<div class="col-md-6" style="border-left: 1px solid #e0e0e0;">
													<div class="form-group">
														<label><strong>Chip</strong></label>
														<select class="form-control" [(ngModel)]="configuracao.chip" name="chip" 
															[disabled]="pedido.id_status >= 6">
															<option [ngValue]="'rastreei'">Rastreei</option>
															<option [ngValue]="'outra'">Outra</option>
														</select>
													</div>
													
													<!-- Campos adicionais para chip personalizado -->
													<div *ngIf="configuracao.chip === 'outra'" class="mt-2">
														<div class="form-group">
															<label><strong>Chip: Domínio</strong></label>
															<input type="text" class="form-control" 
																[(ngModel)]="configuracao.chipConfig.dominio" 
																name="chipDominio"
																[disabled]="pedido.id_status >= 6">
														</div>
														<div class="form-group">
															<label><strong>Chip: Usuário</strong></label>
															<input type="text" class="form-control" 
																[(ngModel)]="configuracao.chipConfig.usuario" 
																name="chipUsuario"
																[disabled]="pedido.id_status >= 6">
														</div>
														<div class="form-group">
															<label><strong>Chip: Senha</strong></label>
															<input type="text" class="form-control" 
																[(ngModel)]="configuracao.chipConfig.senha" 
																name="chipSenha"
																[disabled]="pedido.id_status >= 6">
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="mt-2">
											<button type="button" class="btn btn-primary" (click)="confirmarConfiguracao()" 
												[disabled]="!isConfiguracaoValida()"
												*ngIf="pedido.id_status == 5">
												<i data-feather="check" class="mr-25"></i>
												Confirmar Configuração
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Envio Pronto section - only shown when id_status equals 6 -->
					<div class="card invoice-preview-card mt-2" *ngIf="pedido.id_status >= 6">
						<!-- Header bar that's always visible -->
						<div class="card-header d-flex justify-content-between align-items-center bg-primary" style="cursor: pointer; color: white;" (click)="isEnvioProntoCollapsed = !isEnvioProntoCollapsed">
							<h3 class="mb-0" style="color: white;">Envio</h3>
							<button class="btn btn-link p-0" type="button" style="color: white;">
								<i class="fa" [ngClass]="isEnvioProntoCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
							</button>
						</div>
				
						<!-- Collapsible content -->
						<div [hidden]="isEnvioProntoCollapsed">
							<div class="card-body invoice-padding pt-2">
								<div class="row">
									<div class="col-12 text-center">
										<h4>Etiqueta de Rastreamento</h4>
										<div class="qrcode-container">
											<ngx-qrcode 
												*ngIf="pedido && pedido.num_pedido"
												[elementType]="'img'"
												[errorCorrectionLevel]="'M'"
												[value]="currentPageUrl"
												cssClass="qrcode-image-large"
											></ngx-qrcode>
											<div *ngIf="!pedido || !pedido.num_pedido" class="alert alert-warning">
												Não foi possível gerar o QR code. Verifique se o número do pedido está correto.
											</div>
										</div>
										<p class="mb-3">QR Code para rastreamento do pedido #{{pedido.num_pedido}}. Cole no pacote de envio.</p>
										<div class="d-flex justify-content-center mb-3">
											<button type="button" class="btn btn-primary mr-1" (click)="imprimirEtiqueta()">
												<i data-feather="printer" class="mr-25"></i>
												Imprimir Etiqueta
											</button>
											<button type="button" class="btn btn-outline-secondary" (click)="confirmarEnvio()" *ngIf="pedido.id_status == 6">
												<i data-feather="check" class="mr-25"></i>
												Confirmar Envio
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">

					<div class="card">
						<div class="card-body">
							<button routerLink="/pedido-rastreador/" class="btn btn-outline-primary btn-block mb-75" rippleEffect>
								Voltar
							</button>
							<button *ngIf="pedido.id_pedido == null" class="btn btn-primary btn-block mb-75"
								(click)="efetuarPedido(false)" 
								[disabled]="loading || contrato.id_contrato != null || !todosItensValidos()"
								rippleEffect>
								<span *ngIf="loading && !loadingContrato"
									class="spinner-border spinner-border-sm mr-1"></span>
								<span>Efetuar Pedido</span>
								<span *ngIf="pedido.id_pedido != null">Atualizar Pedido</span>
							</button>
							<div *ngIf="!todosItensValidos()" class="text-danger text-center mb-2">
								Preencha todos os campos
							</div>
							<button *ngIf="pedido.id_pedido != null && pedido.id_status < 2"
								class="btn btn-primary btn-block mb-75" (click)="gerarContrato(true)"
								[disabled]="loading" rippleEffect>
								<span *ngIf="loadingContrato" class="spinner-border spinner-border-sm mr-1"></span>
								<span>Aprovar Pagamento</span>
							</button>
							<!-- End of status indicator -->
						</div>
					</div>

					<!-- status -->
					<div class="order-status-indicator-vertical" *ngIf="pedido.id_pedido != null">
						<div class="status-step" [class.active]="pedido.id_status >= 1">
							<i><i data-feather="credit-card" class="mr-25"></i></i>
							<span>AGUARDANDO PAGAMENTO</span>
						</div>
						<div class="status-step" [class.active]="pedido.id_status >= 4">
							<i><i data-feather="list" class="mr-25"></i></i>
							<span>EM SEPARAÇÃO</span>
						</div>
						<div class="status-step" [class.active]="pedido.id_status >= 5">
							<i><i data-feather="settings" class="mr-25"></i></i>
							<span>EM CONFIGURAÇÃO</span>
						</div>
						<div class="status-step" [class.active]="pedido.id_status >= 6">
							<i><i data-feather="check-square" class="mr-25"></i></i>
							<span>PRONTO PARA ENVIO</span>
						</div>
						<div class="status-step" [class.active]="pedido.id_status >= 7">
							<i><i data-feather="truck" class="mr-25"></i></i>
							<span>ENVIADO</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>

<style>
.order-status-indicator-vertical {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    position: relative;
    width: 80%;
    max-width: 300px;
}

/* Timeline line */
.order-status-indicator-vertical::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 40px;
    width: 2px;
    height: calc(100% - 60px);
    background-color: #e0e0e0;
    z-index: 0;
}

.order-status-indicator-vertical .status-step {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    width: 100%;
}

.order-status-indicator-vertical .status-step i {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #6c757d;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    position: relative;
    z-index: 2;
}

/* Adjusted styles for the inner feather icon */
.order-status-indicator-vertical .status-step i i[data-feather] {
    width: 20px;  
    height: 20px;
    stroke-width: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 !important; /* Remove any margin that might affect centering */
    position: absolute; /* Use absolute positioning */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* Perfect centering */
}

.order-status-indicator-vertical .status-step.active i {
    background-color: #007bff;
}

.order-status-indicator-vertical .status-step span {
    font-size: 14px;
    color: #333;
    flex: 1;
}

.qrcode-image {
  width: 250px;
  height: 250px;
  margin: 0 auto;
  display: block;
}

.qrcode-image-large {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  display: block;
}
</style>